<template>
  <base-card>
    <base-card-body class="flex flex-col gap-2">
      <h1>
        Invitez une pharmacie
      </h1>
      <p class="text-primary">
        Les pharmacies qui rejoindront votre groupe <strong>gagneront 1 mois gratuit</strong>, et vous aussi !
      </p>
      <form
        class="flex flex-col gap-4"
        @submit.prevent="sendInvitation"
      >
        <healthcenter-search-bar @select="handleHealthcenterSelected" />
        <div class="flex flex-1 items-center gap-x-6 gap-y-2 flex-wrap">
          <label>Email de la pharmacie à inviter</label>
          <input
            v-model="email"
            type="email"
            class="flex flex-1 bg-gray-200 border border-gray-300 p-2 rounded-md focus:outline-none focus:ring-primary focus:border-primary"
            placeholder="Adresse email de la pharmacie"
            required
          >
          <button
            type="submit"
            class="text-primary font-bold p-2"
            :disabled="loading"
          >
            <span v-if="!loading">Envoyer</span>
            <span v-if="loading">
              <base-spinner
                size="button"
              />
            </span>
          </button>
        </div>
      </form>
    </base-card-body>
  </base-card>
</template>

<script setup lang="ts">
import {ref} from 'vue';
import {Healthcenter} from "@/core/interfaces/healthcenter/Healthcenter";
import {disruptionLogisticsApi} from "@/container";
import {useToastStore} from "@/stores/toast.store";
import BaseCard from "@/core/components/base/BaseCard.vue";
import BaseCardBody from "@/core/components/base/BaseCardBody.vue";
import BaseSpinner from "@/core/components/base/spinner/BaseSpinner.vue";
import HealthcenterSearchBar from "@/healthcenter/components/HealthcenterSearchBar.vue";

const props = defineProps<{ healthcenterGroupId: number | null }>();
const emits = defineEmits(['invitationSent']);

const loading = ref(false);
const email = ref<string | null>(null);
const healthcenter = ref<Healthcenter>();

/**
 * Send the invitation.
 */
const sendInvitation = () => {
    if (loading.value || !email.value || !healthcenter.value || !props.healthcenterGroupId) {
        return;
    }

    loading.value = true;
    return disruptionLogisticsApi()
        .createInvitation(props.healthcenterGroupId, email.value, healthcenter.value.id)
        .then((invitation) => {
            const toast = useToastStore();

            toast.showSuccess({content: 'Invitation envoyée'});
            emits('invitationSent', invitation);
            email.value = null;
        })
        .finally(() => {
            loading.value = false;
        });
};

const handleHealthcenterSelected = (newHealthcenter: Healthcenter) => {
    healthcenter.value = newHealthcenter;
};

</script>

